import React from "react";
import { Link } from "react-router-dom";
import { getImageBaseUrl } from "../services/s3-utils";

function QalortFooter(props) {
  return (
    <footer className="bg-black-neutral app-container py-8 lg:py-20">
      <div className="app-container-section">
        <div className="flex justify-between flex-wrap gap-14 gap-y-8">
          <div>
            <h6 className="white mb-[35px] text-white">Company</h6>

            <ul className="mb-0">
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/build-with-us">Build With Us</Link>
              </li>
              <li>
                <Link to="/career">Careers</Link>
              </li>
              <li>
                <Link to="/affiliates">Affiliate</Link>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="white mb-[35px] text-white">Teach</h6>

            <ul className="mb-0">
              <li>
                <Link to="/starter-guide">Starter Guide</Link>
              </li>
              <li>
                <Link to="/mentorship">Mentorship</Link>
              </li>
              <li>
                <Link to="/top-mentors">Top Mentors</Link>
              </li>
              <li>
                <Link to="/help-center">Help Center</Link>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="white mb-[35px] text-white">More</h6>

            <ul className="mb-0">
              <li>
                <Link to="/terms">Terms Of Use</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/FAQ">FAQs</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex justify-between mt-8 md:mt-[108px] items-center flex-wrap">
          <div className="flex items-center gap-2.5">
            <Link to="/">
              <img src={`${getImageBaseUrl}/assets/logo-blue.svg`} alt="" />
            </Link>
            <span className="md:ml-3 text-placeholder text-xs leading-5 sm:p-xs sm:leading-[25px]">
              Copyright © Qalort Inc. {new Date().getFullYear()}. All rights
              reserved
            </span>
          </div>
          <div className="flex gap-[30px] mt-5 [@media(min-width:514px)]:mt-0">
            <a href="https://www.instagram.com/qalort/" target="_blank" rel="noreferrer">
              <img src={`${getImageBaseUrl}/assets/ig.svg`} alt="" />
            </a>
            <a href="https://twitter.com/officialqalort" target="_blank" rel="noreferrer">
              <img src={`${getImageBaseUrl}/assets/twitter.svg`} alt="" />
            </a>
            <a href="https://www.facebook.com/qalort" target="_blank" rel="noreferrer">
              <img src={`${getImageBaseUrl}/assets/fbk.svg`} alt="" />
            </a>
            {/* <img src={`${getImageBaseUrl}/assets/youtube.svg`} alt="" className="mr-1 md:ml-12" /> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default QalortFooter;
